import React from "react";
import AppVersionManagement from "../components/appversion";

function AppVersionPage() {
  return (
    <div>
      <AppVersionManagement />
    </div>
  );
}

export default AppVersionPage;
